/** @jsxImportSource @emotion/react */
export default function ProductoEnCertificado(props) {
  return (
    <div>
      {props.producto.producto_x_productocampospropios.map(
        (campoPropio, indexCampoPropio) => {
          return (
            <div key={indexCampoPropio}>
              <span>
                {campoPropio.productocampospropios.etiqueta}:{" "}
                <span css={{ fontWeight: "600" }}>
                  {campoPropio.valor}
                  {campoPropio.productocampospropios.unidades && ` ${campoPropio.productocampospropios.unidades}`}
                </span>
              </span>
            </div>
          );
        },
      )}
    </div>
  );
}
